import React from "react";

export const RBEListContext = React.createContext({});
